(function () {
  'use strict';

  function initSlideshow(section) {
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-hero-slide]'));
    var textPanels = Array.prototype.slice.call(section.querySelectorAll('[data-hero-text-panel]'));
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('[data-hero-thumb]'));
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-hero-dot]'));
    var counterCurrent = section.querySelector('[data-hero-counter-current]');
    var cta = section.querySelector('[data-hero-cta]');
    var ctaLabel = section.querySelector('[data-hero-cta-label]');

    if (slides.length === 0) return;

    var current = 0;
    var autoplay = section.dataset.autoplay === 'true';
    var interval = parseInt(section.dataset.interval, 10) || 6000;
    var timer = null;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function updateCta(panel) {
      if (!cta || !panel) return;
      var label = panel.dataset.buttonLabel || '';
      var link = panel.dataset.buttonLink || '#';

      if (!label) {
        cta.style.display = 'none';
        return;
      }

      cta.style.display = '';
      cta.setAttribute('href', link);
      if (ctaLabel) ctaLabel.textContent = label;
    }

    function playVideoIn(slide) {
      var videos = slide.querySelectorAll('[data-hero-video]');
      videos.forEach(function (video) {
        var p = video.play();
        if (p !== undefined) p.catch(function () {});
      });
    }

    function pauseVideoIn(slide) {
      var videos = slide.querySelectorAll('[data-hero-video]');
      videos.forEach(function (video) {
        video.pause();
      });
    }

    function goTo(index) {
      var next = (index + slides.length) % slides.length;
      if (next === current) return;

      slides[current].classList.remove('is-active');
      pauseVideoIn(slides[current]);
      textPanels[current].classList.remove('is-active');
      if (thumbs[current]) thumbs[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = next;

      slides[current].classList.add('is-active');
      playVideoIn(slides[current]);
      textPanels[current].classList.add('is-active');
      if (thumbs[current]) thumbs[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');

      if (counterCurrent) {
        counterCurrent.textContent = String(current + 1).padStart(2, '0');
      }

      updateCta(textPanels[current]);
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      if (!autoplay || reducedMotion || slides.length < 2) return;
      stopAutoplay();
      timer = window.setInterval(next, interval);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    playVideoIn(slides[current]);
    updateCta(textPanels[current]);
    startAutoplay();
  }

  function initAll() {
    document.querySelectorAll('[data-hero-slideshow]').forEach(initSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-hero-slideshow]');
    if (section) initSlideshow(section);
  });
})();